/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
// import {KTSVG} from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { checkPermission } from '../../../../../app/utils/checkPermission'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      {checkPermission('Dashboard', 'view') && (
        <SidebarMenuItem
          to='/dashboard'
          icon='/media/icons/duotune/graphs/gra010.svg'
          title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
          fontIcon='bi-app-indicator'
        />
      )}
      {checkPermission('Offers', 'list') && (
        <SidebarMenuItem
          to='offer-management/offers'
          title='Offers'
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/general/gen026.svg'
        />
      )}

      {checkPermission('Offer With Price', 'list') && (
        <SidebarMenuItem
          to='/offer-with-price'
          title='Offer With Price'
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/general/gen026.svg'
        />
      )}

      {checkPermission('Seller Messaging Module', 'list') && (
        <SidebarMenuItem
          to='/seller-message-module'
          title='Seller Messaging Module'
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/general/gen026.svg'
        />
      )}

      {checkPermission('Multiple Offer With Price', 'list') && (
        <SidebarMenuItem
        to='/multiple-offer-with-price'
        title='Multiple Offer With Price'
        fontIcon='bi-chat-left'
        icon='/media/icons/duotune/general/gen026.svg'
        />
      )}

      {checkPermission('Lowest Price Offers For All Product Groups', 'list') && (
        <SidebarMenuItem
          to='/product-group-offer-price'
          title='Lowest Offer With Price'
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/general/gen026.svg'
        />
      )}

      {checkPermission('Buyer Wise Inquiry Price', 'list') && (
        <SidebarMenuItem
          to='/buyer-wise-inquiry-price'
          title='Buyer Wise Inquiry Price'
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/general/gen026.svg'
        />
      )}
      {(checkPermission('Inquiries', 'list') || checkPermission('Quotations', 'list') || checkPermission('Purchase orders', 'list') || checkPermission('Buyers', 'list') || checkPermission('Sellers', 'list')) && (
        <>
          {checkPermission('Inquiries', 'list') && (
            <SidebarMenuItem
              to='/inquiry-management/inquiries'
              title='Inquiries'
              fontIcon='bi-chat-left'
              icon='/media/icons/duotune/communication/com003.svg'
            />
          )}
          {checkPermission('Quotations', 'list') && (
            <SidebarMenuItem
              to='quotation-management/quotations'
              title='Quotations'
              fontIcon='bi-chat-left'
              icon='/media/icons/duotune/files/fil006.svg'
            />
          )}
          {checkPermission('Purchase orders', 'list') && (
            <SidebarMenuItem
              to='purchase-order/purchases'
              title='Purchase orders'
              fontIcon='bi-chat-left'
              icon='/media/icons/duotune/general/gen005.svg'
            />
          )}
          {checkPermission('Buyers', 'list') && (
            <SidebarMenuItem
              to='buyer-management/buyers'
              title='Buyers'
              fontIcon='bi-archive'
              icon='/media/icons/duotune/ecommerce/ecm001.svg'
            />
          )}
          {checkPermission('Sellers', 'list') && (
            <SidebarMenuItem
              to='seller-management/sellers'
              title='Sellers'
              icon='/media/icons/duotune/ecommerce/ecm004.svg'
              fontIcon='bi-person'
            />
          )}
        </>
      )}
      {(checkPermission('Grade Groups', 'list') || checkPermission('Product Groups', 'list') || checkPermission('Products', 'list') || checkPermission('Locations', 'list') || checkPermission('Roles', 'list') || checkPermission('Users', 'list') || checkPermission('Copy Freights', 'list') || checkPermission('Transporters', 'list') || checkPermission('Banners', 'list')) && (
        <SidebarMenuItemWithSub
          to='/#'
          title='Masters'
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/abstract/abs015.svg'
        >
          {checkPermission('Grade Groups', 'list') && (
            <SidebarMenuItem
              to='/grade-group-management/grades'
              title='Grade Groups'
              hasBullet={true}
            />
          )}
          {checkPermission('Product Groups', 'list') && (
            <SidebarMenuItem
              to='/product-group-management/Products'
              title='Product Groups'
              hasBullet={true}
            />
          )}

           {checkPermission('Quantity Wise Profit', 'list') && (
            <SidebarMenuItem
              to='/quantity-profit'
              title='Quantity Profit'
              hasBullet={true}
            />
           )}
          {checkPermission('Products', 'list') && (
            <SidebarMenuItem
              to='/product-management/products'
              title='Products'
              hasBullet={true}
            />
          )}
          {checkPermission('Locations', 'view') && (
            <SidebarMenuItem
              to='/masters/locations'
              title='Locations'
              hasBullet={true}
            />
          )}
          {checkPermission('Roles', 'list') && (
            <SidebarMenuItem
              to='/masters/roles'
              title='Roles'
              hasBullet={true}
            />
          )}
          {checkPermission('Users', 'list') && (
            <SidebarMenuItem
              to='masters/users/users'
              title='Users'
              hasBullet={true}
            />
          )}
          {checkPermission('Copy Freights', 'list') && (
            <SidebarMenuItem
              to='/copy-freight-management/freights'
              title='Copy Freights'
              hasBullet={true}
            />
          )}
          {checkPermission('Transporters', 'list') && (
            <SidebarMenuItem
              to='masters/transports/transports'
              title='Transporters'
              hasBullet={true}
            />
          )}
          {checkPermission('Banners', 'list') && (
            <SidebarMenuItem
              to='/masters/banners'
              title='Banners'
              hasBullet={true}
            />
          )}
        </SidebarMenuItemWithSub>
      )}
      {(checkPermission('Usage Analysis', 'view') || checkPermission('Order Duration Analysis', 'view') || checkPermission('Inquiry to Invoice Analysis', 'view') || checkPermission('Grade Group Wise Report', 'view') || checkPermission('Near to Expiry Offers', 'view') || checkPermission('Active Inquiries', 'view') || checkPermission('Recently Completed Inquiries', 'view') || checkPermission('User Wise Inquiry', 'view') || checkPermission('Operation Report', 'view') || checkPermission('Message Logs', 'list')) && (
        <SidebarMenuItemWithSub
          to='/#'
          title='Reports'
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/general/gen005.svg'
        >
          {checkPermission('Usage Analysis', 'view') && (
            <SidebarMenuItem
              to='/buyerseller-report/buyersellers'
              title='Usage Analysis'
              hasBullet={true}
            />
          )}
          {checkPermission('Order Duration Analysis', 'view') && (
            <SidebarMenuItem
              to='/order-report/orders'
              title='Order Duration Analysis'
              hasBullet={true}
            />
          )}
          {checkPermission('Inquiry to Invoice Analysis', 'view') && (
            <SidebarMenuItem
              to='/inquiry-report/inquirys'
              title='Inquiry to Invoice Analysis'
              hasBullet={true}
            />
          )}
          {checkPermission('Grade Group Wise Report', 'view') && (
            <SidebarMenuItem
              to='/grade-group-report/gradegroups'
              title='Grade Group Wise Report'
              hasBullet={true}
            />
          )}
          {checkPermission('Near to Expiry Offers', 'view') && (
            <SidebarMenuItem
              to='/near-expire-offer/expireoffers'
              title='Near to Expiry Offers'
              hasBullet={true}
            />
          )}
          {checkPermission('Active Inquiries', 'view') && (
            <SidebarMenuItem
              to='/active-inquiry-report/activeinquiries'
              title='Active Inquiries'
              hasBullet={true}
            />
          )}
          {checkPermission('Recently Completed Inquiries', 'view') && (
            <SidebarMenuItem
              to='/complete-inquiry-report/completeinquiries'
              title='Recently Completed Inquiries'
              hasBullet={true}
            />
          )}
          {checkPermission('User Wise Inquiry', 'view') && (
            <SidebarMenuItem
              to='/userwise-inquiry-report/userinquiries'
              title='User Wise Inquiry'
              hasBullet={true}
            />
          )}
          {checkPermission('Operation Report', 'view') && (
            <SidebarMenuItem
              to='/operation-report/operation'
              title='Operation Report'
              hasBullet={true}
            />
          )}
          {checkPermission('Message Logs', 'list') && (
            <SidebarMenuItem
              to='/message-management'
              title='Message'
              hasBullet={true}
            />
          )}
        </SidebarMenuItemWithSub>
      )}
      {(checkPermission('News Articles', 'list') || checkPermission('Category', 'list') )&& (
        <>
          {(checkPermission('News Articles', 'list') || checkPermission('Category', 'list')) && (
            <SidebarMenuItemWithSub
              to='/news-content'
              title='Manage News'
              fontIcon='bi-chat-left'
              icon='/media/icons/duotune/coding/cod001.svg'
            >
              {checkPermission('News Articles', 'list') && (
                <SidebarMenuItem
                  to='/news-articles/articles'
                  title='News Articles'
                  hasBullet={true}
                />
              )}

              {checkPermission('Category', 'list') && (
                <SidebarMenuItem
                  to='/news-category/cates'
                  title='Category'
                  hasBullet={true}
                />
              )}


            </SidebarMenuItemWithSub>
          )} </>
 )}
          {checkPermission('Settings', 'view') && (
            <>
              
              <SidebarMenuItem
                to='/setting'
                title='Settings'
                fontIcon='bi-chat-left'
                icon='/media/icons/duotune/coding/cod001.svg'
              />
            </>
          ) }


      {/* {checkPermission('Messages', 'list') && (
        <SidebarMenuItem
          to='/message-management/messages'
          title='Messages'
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/communication/com003.svg'
        />
      )}
       */}


       
     
    
    </>
  )
}

export { SidebarMenuMain }
